import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Clock, Users, PhoneOff, BarChart3 } from 'lucide-react';
const benefits = [{
  icon: Zap,
  title: '90% Faster Screening',
  description: 'AI processes applications, checks records, and scores candidates in minutes, not weeks.'
}, {
  icon: ShieldCheck,
  title: 'Safe Driver Profiles Identified',
  description: 'AI automatically analyzes driving history, experience, and safety records to surface the safest, most qualified candidates.'
}, {
  icon: Clock,
  title: '24/7 Hiring Pipeline',
  description: 'Drivers apply and get screened around the clock. Wake up to pre-qualified candidates.'
}, {
  icon: Users,
  title: 'Reduce Driver Turnover',
  description: 'Better upfront matching and qualification means drivers stay longer and perform better.'
}, {
  icon: PhoneOff,
  title: 'No More Phone Tag',
  description: 'Automated SMS scheduling, document collection, and communication with candidates.'
}, {
  icon: BarChart3,
  title: 'Dashboard & Analytics',
  description: 'Real-time visibility into your hiring pipeline, time-to-hire metrics, and bottleneck alerts.'
}];
export function Benefits() {
  return <section id="features" className="py-24 bg-slate-50" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-15">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-16">
            Built for Logistics. Built for Speed.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-17">
            Everything you need to scale your fleet, packed into one automated
            platform.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-18">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all group" data-id="element-19">
              <div className="w-12 h-12 rounded-xl bg-slate-50 group-hover:bg-blue-50 flex items-center justify-center mb-6 transition-colors" data-id="element-20">
                <benefit.icon className="w-6 h-6 text-slate-700 group-hover:text-blue-600 transition-colors" data-id="element-21" />
              </div>
              <h3 className="text-xl font-display font-bold text-slate-900 mb-3" data-id="element-22">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-23">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}